/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Empty_DescriptionInputs */

const es_settings_files_empty_description = /** @type {(inputs: Settings_Files_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentá ajustar los filtros o ingestar nuevos archivos desde tus fuentes conectadas.`)
};

const en_settings_files_empty_description = /** @type {(inputs: Settings_Files_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try adjusting your filters or ingesting new files from your connected sources.`)
};

/**
* | output |
* | --- |
* | "Try adjusting your filters or ingesting new files from your connected sources." |
*
* @param {Settings_Files_Empty_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_empty_description = /** @type {((inputs?: Settings_Files_Empty_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Empty_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_empty_description(inputs)
	return en_settings_files_empty_description(inputs)
});
export { settings_files_empty_description as "settings.files.empty.description" }